module.exports = __webpack_public_path__ + "media/images/users/user-1-ddf1806276a08a38bd8e96ee64baee6d.jpg";